import React, { Component } from "react";
import { Layout, Menu, Radio, Checkbox, Button, message, Pagination, Select, Input, Form } from "antd";
import Header from "../../components/header";
import { reqChangeQue, reqDeletePaper, reqPaper, reqPickQue, reqRandomQue, reqCheckListA, reqChoiceDetails, reqCheckListX, reqCheckListB, reqCategory, reqModification, reqPublishexam } from "../../api";

import './preview.less'
import Modal from "antd/es/modal";

const { Content, Sider } = Layout;
const { Option } = Select;

/**
 * 预览试卷综合考核的路由组件
 */
class PreviewCom extends Component {

    state = {
        total: 0,
        page: 1,
        size: 10,
        pid: 0,
        paper: {},
        qA: {},
        qB: {},
        qX: {},
        qCase: {},
        totalScore: 0,
        pStatus: "inline-block",
        pStatusN: "none",
        visible: false,
        amendvisible: false, //修改试卷名称
        compile: false,
        // refId: "",
        checkList: {},
        choice: "",
        flag: 0,
        category: [],
        cid: "",
        quantity: "",
        question: '',
        publishId: '',
        publishStatus: ''
    };

    getPublishexam = async (id) => {
        const result = await reqPublishexam(id);
        if (result.code === '000000') {
            // console.log(result.data);
            // this.stateDRAFT
            this.setState({
                publishStatus: result.data,
            })
        }
    }



    preview = (e, id) => {
        sessionStorage.setItem("pid", this.state.pid);
        switch (id) {
            case 1:
                this.props.history.replace("/previewCom");
                break;
            case 2:
                this.props.history.replace("/previewIll");
                break;
            case 3:
                this.props.history.replace("/paper");
                break;
            default:
                this.props.history.replace("/previewCom");
        }
    };

    getPaper = async (id) => {
        this.publishId = id
        // console.log(this.publishId);
        const result = await reqPaper(id);
        // const res = await reqPublishexam(id);
        // console.log(res);
        /*  let qbScore = 0;
         if (result.data.qb) {
             qbScore = result.data.qb.scorePer * result.data.qb.total;
         } */
        let totalScore = 0;
        for (let item in result.data) {
            let obj = result.data[item];
            if (obj.scorePer) {
                totalScore = totalScore + obj.scorePer * obj.total;
                // console.log("属性" + item + "进行了加操作,当前总值为：" + totalScore);
            }
            // console.log(result.data[item]);
        }

        this.setState({
            paper: result.data,
            qA: result.data.qa,
            qB: result.data.qb,
            qX: result.data.qx,
            totalScore: totalScore,
        })
        // const obj = [];
        // for (let index = 0; index < result.data.qa.questions.length; index++) {
        //     const element = result.data.qa.questions[index];
        //     obj.push(element.refId);
        // }
        // this.refId = obj.join(",");
        // // 存入qa的id
        // sessionStorage.setItem("refId", this.refId)

    };

    pubPaper = async () => {
        this.props.history.replace("/paper");
    };

    changeQue = async (item) => {
        let data = {
            type: item.questionType,
            testPaperId: this.state.pid,
            size: 1
        };
        if (item.questionType === 'B') {
            data["questionsCnt"] = item.questions.length
        }
        const result = await reqRandomQue(data);
        const res = await reqChangeQue(this.state.pid, item.refId, result.data.rows[0].refId);
        if (res.code === '000000') {
            message.success("替换成功");
            this.getPaper(this.state.pid)
        }
    };

    pickQue = async () => {
        const result = await reqPickQue(this.state.pid, "SKILL");
        if (result.code === '000000') {
            message.success("替换成功");
            this.getPaper(this.state.pid)
        }
    };

    replaceChoice = async (item) => {
        if (this.choice) {
            let data = {
                type: item.questionType,
                testPaperId: this.state.pid,
                size: 1
            };
            if (item.questionType === 'B') {
                data["questionsCnt"] = item.questions.length
            }
            // const result = await reqRandomQue(data);
            const res = await reqChangeQue(this.state.pid, this.ids, this.choice);
            if (res.code === '000000') {
                message.success("替换成功");
                this.getPaper(this.state.pid)
                this.setState({
                    compile: false,
                })
                this.choice = ""

            }
        } else {
            message.info("请先选择要替换的题目");
        }

    };
    /* replaceChoice = async (e) => {
        // e.target.id
        const result = await reqChoiceDetails(this.choice);
        if (result.code === '000000') {
            message.success("替换成功");
            this.setState({
                compile: false,
            })
            // this.getPaper(this.state.pid)
        }
    } */



    getCheckListA = async (data) => {
        const result = await reqCheckListA(data);
        if (result.code === '000000') {
            this.setState({
                total: result.data.total,
                page: result.data.page,
                checkList: result.data,
            });
        }
    };

    getCheckListB = async (data) => {
        const result = await reqCheckListB(data);
        if (result.code === '000000') {
            this.setState({
                total: result.data.total,
                page: result.data.page,
                checkList: result.data,
            });
        }
    };

    getCheckListX = async (data) => {
        const result = await reqCheckListX(data);
        if (result.code === '000000') {
            this.setState({
                total: result.data.total,
                page: result.data.page,
                checkList: result.data,
            });
        }
    };



    compileChange = async (item) => {
        this.choice = ""
        this.flag = 1
        let data = {
            page: 1,
            size: 10,
        };
        this.getCheckListA(data);
        this.getCategoryList("SKILL");
        this.ids = item.refId
        this.setState({
            compile: true,
        })
    };

    compileChangeB = async (item) => {
        this.choice = ""
        this.quantity = item.questions.length
        this.flag = 2
        let data = {
            page: 1,
            size: 10,
            questionsCnt: item.questions.length
        };
        this.getCheckListB(data);
        this.getCategoryList("SKILL")
        this.ids = item.refId
        this.setState({
            compile: true,
        })
    };

    compileChangeX = async (item) => {
        this.choice = ""
        this.flag = 3
        let data = {
            page: 1,
            size: 10,
        };
        this.getCheckListX(data);
        this.getCategoryList("SKILL")
        this.ids = item.refId
        this.setState({
            compile: true,
        })
    };

    locating = async () => {
        let name = document.getElementsByClassName("search_name")[0].value;
        let data = {
            cid: this.cid,
            page: 1,
            size: 10,
            questionsCnt: this.quantity
        };
        if (this.flag == 1) {
            if (name && name !== '') {
                data["question"] = name;
                this.setState({
                    question: name
                })
            }
            this.getCheckListA(data);
        }
        if (this.flag == 2) {
            if (name && name !== '') {
                data["question"] = name;
                this.setState({
                    question: name
                })
            }
            this.getCheckListB(data);
        }
        if (this.flag == 3) {
            if (name && name !== '') {
                data["question"] = name;
                this.setState({
                    question: name
                })
            }
            this.getCheckListX(data);
        }
    }

    maxPic = (pics) => {
        Modal.info({
            title: '',
            width: '40%',
            okText: '关闭',
            icon: 'none',
            className: 'pic',
            content: (
                <div>
                    <img style={{ width: "100%", height: "auto" }} src={global.constant.uploadImage + pics[0]} />
                </div>
            ),
            onOk() { },
        });
    };

    showDeleteModal = () => {
        this.setState({
            visible: true
        });
    };

    //修改试卷模态框
    amend = () => {
        this.setState({
            amendvisible: true
        })
        // document.getElementById("inputname").value = document.getElementById("casename").value 
        // console.log(document.getElementById("casename").value );
        // this.state.paper.name = document.getElementById("casename").value 
    }

    deletePaper = async () => {
        const result = await reqDeletePaper(this.state.pid);
        if (result.code === '000000') {
            sessionStorage.clear();
            this.props.history.push("/paper");
        }
    };


    handleCancel = () => {
        this.setState({
            visible: false,
            compile: false,
            amendvisible: false
        });
        this.cid = ""
    };

    componentDidMount = async () => {
        this.setState({
            pid: sessionStorage.getItem("pid"),
            pStatus: sessionStorage.getItem("pStatus") ? sessionStorage.getItem("pStatus") : "inline-block",
            pStatusN: sessionStorage.getItem("pStatusN"),
        });
        this.getPaper(sessionStorage.getItem("pid"));
        this.getPublishexam(sessionStorage.getItem("pid"));
    };

    showTotal = (total) => {
        return '共' + total + '条记录';
    };

    itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    pageClick = async page => {
        const name = document.getElementById("search_input").value;
        let data = {
            page: page,
            size: 10,
            cid: this.cid,
            questionsCnt: this.quantity
        };
        if (this.flag == 1) {
            if (name !== '') {
                data["question"] = name;
            }
            this.getCheckListA(data);
        }
        if (this.flag == 2) {
            if (name !== '') {
                data["question"] = name;
            }
            this.getCheckListB(data);
        }
        if (this.flag == 3) {
            if (name !== '') {
                data["question"] = name;
            }
            this.getCheckListX(data);
        }

    };

    getCategoryList = async (type) => {
        const result = await reqCategory(type);
        // console.log(result.data.rows)
        if (result.code === '000000') {
            this.setState({
                category: result.data.rows
            })
        } else {
            message.error(result.msg);
        }
    };

    SelectonChange = e => {
        // console.log(e);
        this.cid = e
        this.setState({
            cid: e

        });
        // console.log(cid);
    };

    redact = (item) => {
        sessionStorage.setItem("redactId", item.refId);
        sessionStorage.setItem("paperId", this.state.paper.id)
        // console.log(this.state.paper.id,item.refId);
        this.props.history.push("/Comedit");
        // this.props.history.push("/edit");
        // console.log(item.id);
        // console.log(item.refId);
    };

  
    amendhandleOk = async () => {
        this.props.form.validateFields(async (err,value) => {
            // console.log(value.name);
            if (!err) {
                const result = await reqModification(this.state.paper.id, value.name);
                if (result.code === '000000') {
                    this.getPaper(this.state.pid)
                    message.success('修改成功');
                    this.setState({
                        amendvisible: false
                    })
                }
            }
        })
        // data.append("name", values["name"]);

    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const self = this;
        const { total, page, paper, qA, qB, qX, totalScore, visible, compile, checkList, category, amendvisible, publishStatus } = this.state;
        const onChange = e => {
            this.choice = e.target.id
            // console.log(e.target.id);
            // setValue(e.target.value);
        };
        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Sider className='case_left'>
                        <Menu style={{ width: 170 }} selectedKeys={['1']}>
                            <Menu.Item id={3} key={3} title={'返回'} onClick={() => this.preview(this, 3)} style={{ display: this.state.pStatusN }}>
                                返回
                            </Menu.Item>
                            <Menu.Item id={1} key={1} title={'综合考核'} onClick={() => this.preview(this, 1)}>
                                综合考核
                            </Menu.Item>
                            <Menu.Item id={2} key={2} title={'病例考核'} onClick={() => this.preview(this, 2)}>
                                病例考核
                            </Menu.Item>
                        </Menu>
                    </Sider>
                    <Content>
                        <div className='preview'>
                            <div className='pre_title'>
                                <div>
                                    <span>试卷名称：</span>
                                    {/* <input id='casename' defaultValue={paper.name} disabled /> */}
                                    <span id='casename'>{paper.name}</span>
                                    <Button type="primary" className='blue' onClick={this.amend.bind(this)}>修改</Button>
                                </div>
                                <div style={{ marginLeft: 50 }}>
                                    <span>试卷总分：</span>
                                    <span>{totalScore}分</span>
                                </div>
                            </div>

                            <div className='pre_publish'>{publishStatus == 'PUBLISHED' ? '试卷已发布，不能对题目进行修改 ' : ''}</div>
                            <div className='all_num'>
                                <div>
                                    <div
                                        className='list_desc'>一、A型题：本题共{qA.total}小题，每小题{qA.scorePer}分,共{qA.total * qA.scorePer}分，在每题给出的所有选项中，只有1个正确选项。
                                    </div>
                                    {
                                        qA.questions && qA.questions.map(function (item, index) {
                                            return (
                                                <div key={index}>
                                                    {
                                                        item.questions && item.questions.map(function (ques, ins) {
                                                            return (
                                                                <div id={ques.id} key={ins} className='list_title'>
                                                                    {1 + index}. {ques.question}
                                                                    {/* <span className='list_change' onClick={self.changeQue.bind(self, item)} >替换</span> */}
                                                                    {/* this.state.publishStatus == 'DRAFT' */}
                                                                    <span className='list_change' onClick={self.redact.bind(self, item)}>{publishStatus == 'DRAFT' ? '|编辑' : ''}</span>
                                                                    <span className='list_change' onClick={self.compileChange.bind(self, item)}>{publishStatus == 'DRAFT' ? '替换 ' : ''}</span>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    <Radio.Group className='list_radio' value={item.questions[0].correctAnswer}>
                                                        {
                                                            item.options && item.options.map(function (order, i) {
                                                                return (
                                                                    <Radio value={order.optionKey} key={i}>
                                                                        <span
                                                                            className='list_circle'>{order.optionKey}</span>{order.optionValue}
                                                                    </Radio>
                                                                )
                                                            })
                                                        }
                                                    </Radio.Group>
                                                    <div className='list_img'>
                                                        <img onClick={self.maxPic.bind(self, item.imgs)}
                                                            src={item.imgs && global.constant.uploadImage + item.imgs[0]} />
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                                <div>
                                    {
                                        qB ? <div>
                                            <div className='list_desc'>二、B型题：本题共{qB.total}小题，每小题{qB.scorePer}分,共{qB.total * qB.scorePer}分，在每题给出的所有选项中，只有1个正确选项。
                                            </div>{
                                                qB.questions && qB.questions.map(function (item, index) {
                                                    return (
                                                        <div key={index}>
                                                            {
                                                                item.questions && item.questions.map(function (second, or) {
                                                                    return (
                                                                        <div key={or}>
                                                                            <div className='list_title'>{1 + or}.{second.question}：
                                                                                {/* <span className='list_change' onClick={self.changeQue.bind(self, item)} style={{ display: self.state.pStatus }}>替换</span> */}
                                                                                <span className='list_change' onClick={self.redact.bind(self, item)}>{publishStatus == 'DRAFT' ? '|编辑' : ''}</span>
                                                                                <span className='list_change' onClick={self.compileChangeB.bind(self, item)} >{publishStatus == 'DRAFT' ? '替换 ' : ''}</span>
                                                                                <span style={{ marginLeft: 30 }}>
                                                                                    {
                                                                                        item.options && item.options.map(function (order, i) {
                                                                                            return (
                                                                                                <span key={i} className={order.optionKey === second.correctAnswer ? 'list_tab tab_all' : 'tab_all'}>{order.optionKey}</span>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                            <div className='list_opt'>
                                                                {
                                                                    item.options && item.options.map(function (opt, j) {
                                                                        return (
                                                                            <div value={opt.optionKey} key={j}>
                                                                                <span
                                                                                    style={{ marginRight: 10 }}>{opt.optionKey}</span>{opt.optionValue}
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                            <div className='list_img type_B'>
                                                                <img onClick={self.maxPic.bind(self, item.imgs)}
                                                                    src={item.imgs && global.constant.uploadImage + item.imgs[0]} />
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            }</div> : <span />
                                    }
                                    {/**/}
                                </div>
                                <div>
                                    
                                    {
                                        true ? <div>
                                             <div className='list_desc'>{qB ? "三" : "二"}、X型题：本题共{qX.total}小题，每小题{qX.scorePer}分,共{qX.total * qX.scorePer}分，在每题给出的所有选项中，有2个或2个以上正确选项。
                                        </div>{
                                            qX.questions && qX.questions.map(function (item, index) {
                                                return (
                                                    <div key={index}>
                                                        {
                                                            item.questions && item.questions.map(function (ques, ins) {
                                                                return (
                                                                    <div id={ques.id} key={ins} className='list_title'>
                                                                        {1 + index}. {ques.question}
                                                                        {/* <span className='list_change' onClick={self.changeQue.bind(self, item)} style={{ display: self.state.pStatus }}>替换</span> */}
                                                                        {/* <span className='list_change' onClick={self.compileChangeX.bind(self, item)}>&nbsp;编辑</span> */}
                                                                        <span className='list_change' onClick={self.redact.bind(self, item)}>{publishStatus == 'DRAFT' ? '|编辑' : ''}</span>
                                                                        <span className='list_change' onClick={self.compileChangeX.bind(self, item)}>{publishStatus == 'DRAFT' ? '替换 ' : ''}</span>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        <Checkbox.Group className='list_checkbox' value={item.questions[0].correctAnswer.split("|")}>
                                                            {
                                                                item.options && item.options.map(function (order, i) {
                                                                    return (
                                                                        <Checkbox value={order.optionKey} key={i}>
                                                                            <span className='list_circle'>{order.optionKey}</span>{order.optionValue}
                                                                        </Checkbox>
                                                                    )
                                                                })
                                                            }
                                                        </Checkbox.Group>
                                                        <div className='list_img'>
                                                            <img onClick={self.maxPic.bind(self, item.imgs)}
                                                                src={item.imgs && global.constant.uploadImage + item.imgs[0]} />
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                        </div>
                                        :
                                        <span />
                                        
                                    }
                                </div>
                            </div>
                            <div className='bottom_btn' style={{ display: this.state.pStatus }}>
                                {/* <div className='bottom_btn'> */}
                                <Button className='gray' onClick={this.showDeleteModal.bind(this)}>取消</Button>
                                <Button className='gray' onClick={this.pickQue.bind(this)}>重新抽题</Button>
                                <Button className='blue' onClick={this.pubPaper.bind(this)}>生成试卷</Button>
                            </div>
                        </div>
                        <Modal
                            title="提示"
                            visible={visible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.deletePaper}
                            onCancel={this.handleCancel}>
                            <div>确定放弃生成当前试卷吗？</div>
                        </Modal>
                        <Modal title={'替换'} visible={compile} centered width={600}
                            onCancel={this.handleCancel} okText="替换" cancelText={"取消"} destroyOnClose='true' onOk={this.replaceChoice}
                        >
                            <div className='search_box'>
                                <label>分类：</label>
                                <Select id='search_select'
                                    style={{ width: 185 }}
                                    onChange={this.SelectonChange.bind(this)}
                                    allowClear={true}>
                                    {
                                        category && category.map((item, index) => (
                                            <Option key={index} value={item.id}>{item.name}</Option>
                                        ))
                                    }
                                </Select>
                                <label style={{ marginLeft: "10px" }}>题干关键字</label>
                                <Input id='search_input' style={{ width: 160 }} className="search_name" />
                                <Button style={{ marginLeft: "10px" }} className='blue' onClick={this.locating.bind(this)}>查找</Button>
                            </div>
                            <div>
                                <Radio.Group onChange={onChange} style={{ width: '100%' }}>
                                    {
                                        checkList.rows && checkList.rows.map(function (item, index) {

                                            return (

                                                <div key={index}>
                                                    {
                                                        item.questions && item.questions.map(function (ques, ins) {
                                                            return (
                                                                <Radio value={ques.id} key={ins} id={`${item.id}`}>
                                                                    <span id={ques.id} key={ins} className='list_circle1'>
                                                                        {1 + index}. {ques.question}
                                                                    </span>
                                                                </Radio>
                                                            )
                                                        })
                                                    }
                                                    {
                                                        item.options && item.options.map(function (order, i) {
                                                            return (
                                                                <div key={i} className='list_radio'>
                                                                    {order.optionKey}. {order.optionValue}
                                                                    {/*  <span className='list_change' onClick={self.changeQue.bind(self, item)} style={{ display: self.state.pStatus }}>替换</span>
                                                                    <span className='list_change' onClick={self.compileChangeX.bind(self, item)}>替换</span> */}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            );
                                        })
                                    }
                                </Radio.Group>
                                <Pagination total={total} current={page} onChange={this.pageClick} itemRender={this.itemRender} showTotal={this.showTotal} />
                            </div>
                        </Modal>
                        <Modal width={600}  title="修改试卷名称" visible={amendvisible} onOk={this.amendhandleOk}
                            onCancel={this.handleCancel}
                            okText="确认" cancelText="取消" destroyOnClose='true' >
                            <Form>
                                <Form.Item label='试卷名称'>
                                    {getFieldDecorator('name', {
                                        rules: [{ required: true, message: '请输入试卷名称!' }],
                                        initialValue: this.state.paper.name
                                    })(
                                        <Input style={{width:'400px'}} className='input' placeholder='请输入新增名称' />,
                                    )}
                                </Form.Item>
                            </Form>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const PreviewComManage = Form.create()(PreviewCom);
export default PreviewComManage;